/**
 * Phase 62 follow-up (2026-09-22) — a device token whose registration is no
 * longer active.
 *
 * Device JWTs (`type: 'device'`, `POST /devices/activate`) are checked
 * against their device row on every HTTP request (`JwtStrategy`) and socket
 * handshake (`device-socket-auth.ts`): a revoked, decommissioned or
 * re-provisioned device's token is refused with THIS message. The POS
 * clients match it to end the enrollment instead of retrying, refreshing a
 * user session, or looping between landing pages — so the server and both
 * clients read one constant.
 */
export const DEVICE_REGISTRATION_INACTIVE_MESSAGE = 'Device registration is not active';

/** True when `message` is the server's inactive-registration refusal
 *  (HTTP 401 body `message`, or a socket `connect_error` message). */
export function isDeviceRegistrationInactiveMessage(message: unknown): boolean {
  return (
    typeof message === 'string' &&
    message.trim().toLowerCase() === DEVICE_REGISTRATION_INACTIVE_MESSAGE.toLowerCase()
  );
}
